import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import {studyMaterialMastercardSavePayment } from '../actions/StudentAction';
import Logo from '../assets/images/logo.png';
import queryString from 'query-string';

const StudyMaterialMasterCardSuccess = () => {
  const [hasUploadedData, setHasUploadedData] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParam = queryString.parse(location.search);

  useEffect(() => {
    if (!hasUploadedData) {
      uploadMastercardData();
      setHasUploadedData(true);   
    }
    
  }, [hasUploadedData]);


  const uploadMastercardData = async () => {
    setLoading(true);
    const formDataToSend = new FormData();
    formDataToSend.append('resultIndicator', queryParam.resultIndicator);
    formDataToSend.append('response',JSON.stringify(queryParam));

    try {
      await studyMaterialMastercardSavePayment(formDataToSend).then((res) => {
        if (res.status) {
          setLoading(false);
          swal('Congratulations Your fee submitted successfully.', '', 'success');
          navigate('/student/dashboard');
        }
      });
    } catch (error) {
      console.log('save payment error...', error);
    }
  };



  return loading ? (
    <div className="screenLoader text-center flex-wrap">
      <img src={Logo} alt="Loading..." style={{ width: '200px' }} />
      <span className="d-block w-100 fw-bold fs-6 text-center" style={{marginTop:'-50px'}}>PLEASE DO NOT REFRESH THE PAGE, AS THE PAYMENT IS CURRENTLY PROCESSING.</span>
    </div>
  ) : (
    ''
  );
};

export default StudyMaterialMasterCardSuccess;
